import { createContext, useContext, type ReactNode } from "react";
import { FEATURES, type FeatureFlag } from "../config/features";

type FeatureFlags = Record<FeatureFlag, boolean>;

const FeatureFlagContext = createContext<FeatureFlags>(FEATURES);

export function FeatureFlagProvider({ children }: { children: ReactNode }) {
  return (
    <FeatureFlagContext.Provider value={FEATURES}>
      {children}
    </FeatureFlagContext.Provider>
  );
}

export function useFeature(flag: FeatureFlag): boolean {
  const flags = useContext(FeatureFlagContext);
  return flags[flag];
}
